type WeightMetricKey = 'carousel' | 'hero' | 'assetMix' | 'assetCount' | 'assetOrder';

/**
 * Fixed identity colors and legend labels for the five formula metrics, in display
 * order. Colors match the Figma score-weights design; weights themselves come from
 * the `weights` prop (eventually the RED-401 breakdown payload).
 */
const WEIGHT_METRICS: Array<{
  key: WeightMetricKey;
  label: string;
  segmentClassName: string;
  /** Bar top-row (earned+available) background color, one shade darker than segmentClassName (e.g. 'bg-pink-500'). */
  barClassName: string;
  /** Bar bottom-row "available" block background color (e.g. 'bg-pink-200'). */
  availableClassName: string;
  /** Text color for the bottom-row "available" block's label (e.g. 'text-pink-700'). */
  availableTextClassName: string;
  accentClassName: string;
  /** 2px bottom border color applied to a formula cell while it's the isolated (hovered) one. */
  underlineClassName: string;
  /** Sentence-case metric name used in the panel's hover insight copy (e.g. "Carousel score"). */
  insightLabel: string;
}> = [
  {
    key: 'carousel',
    label: 'CAROUSEL SCORE',
    segmentClassName: 'bg-pink-400',
    barClassName: 'bg-pink-500',
    availableClassName: 'bg-pink-200',
    availableTextClassName: 'text-pink-700',
    accentClassName: 'text-pink-600',
    underlineClassName: 'border-pink-500',
    insightLabel: 'Carousel score',
  },
  {
    key: 'hero',
    label: 'HERO SCORE',
    segmentClassName: 'bg-purple-400',
    barClassName: 'bg-purple-500',
    availableClassName: 'bg-purple-200',
    availableTextClassName: 'text-purple-700',
    accentClassName: 'text-purple-600',
    underlineClassName: 'border-purple-500',
    insightLabel: 'Hero score',
  },
  {
    key: 'assetMix',
    label: 'ASSET MIX',
    segmentClassName: 'bg-blue-light-400',
    barClassName: 'bg-blue-light-500',
    availableClassName: 'bg-blue-light-200',
    availableTextClassName: 'text-blue-light-700',
    accentClassName: 'text-blue-light-600',
    underlineClassName: 'border-blue-light-500',
    insightLabel: 'Asset mix',
  },
  {
    key: 'assetCount',
    label: 'ASSET COUNT',
    segmentClassName: 'bg-fuchsia-400',
    barClassName: 'bg-fuchsia-500',
    availableClassName: 'bg-fuchsia-200',
    availableTextClassName: 'text-fuchsia-700',
    accentClassName: 'text-fuchsia-600',
    underlineClassName: 'border-fuchsia-500',
    insightLabel: 'Asset count',
  },
  {
    key: 'assetOrder',
    label: 'ASSET ORDER',
    segmentClassName: 'bg-teal-400',
    barClassName: 'bg-teal-500',
    availableClassName: 'bg-teal-200',
    availableTextClassName: 'text-teal-700',
    accentClassName: 'text-teal-600',
    underlineClassName: 'border-teal-500',
    insightLabel: 'Asset order',
  },
];

export { WEIGHT_METRICS };
export type { WeightMetricKey };
